import useIsMobile from '@/hooks/useIsMobile';
import { useEmotionWheelStore } from '../store/useEmotionWheelStore';
import Button from '@/components/Button';
import { AnimatePresence, motion } from 'framer-motion';

export const ResetWheelButton = ({
  onlyMobile,
  show,
  forceShow = false,
}: {
  onlyMobile?: boolean;
  show: boolean;
  forceShow?: boolean;
}) => {
  const { emotionWheelpage, onResetAllAnswers } = useEmotionWheelStore();
  const { isMobile } = useIsMobile();

  if (onlyMobile && !isMobile && !forceShow) {
    return null;
  }

  if (!onlyMobile && isMobile && !forceShow) {
    return null;
  }

  const buttonVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="col-span-5 mt-sh-30 flex w-full flex-col items-center justify-center gap-4 space-x-3 md:flex-row md:gap-0">
      <AnimatePresence>
        {show && (
          <motion.div
            key="reset-button"
            variants={buttonVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex">
            <Button size={'lg'} onClick={() => onResetAllAnswers()} theme="solid-white" className="!text-black">
              {emotionWheelpage?.resetTheWheel || 'Reset the wheel'}
            </Button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* <AnimatePresence>
        <motion.div
          key="mood-tracker-button"
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.5, delay: 0.2 }}>
          <Button
            className={classNames(L2 ? 'flex items-center justify-center' : 'hidden')}
            size={'lg'}
            onClick={() => {
              navigate('/profile');
            }}
            theme="solid">
            {emotionWheelpage?.goToYourMoodTracker || 'Go to your mood tracker'}
          </Button>
        </motion.div>
      </AnimatePresence> */}
    </div>
  );
};
